import {
  Box,
  // Paper,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Grid,
  Card,
} from "@mui/material";
import React, { useContext, useState } from "react";
import FlexButton from "../../../components/FlexButton";
import { colors } from "../../../assets/colors";
import CurrencyList from "../../../components/currencyList";
import SearchIcon from "@mui/icons-material/Search";
import ButtonTabs from "../../../components/ButtonTabs";
import { FlexLayerContext } from "../../../context/flexLayer";
import { useNavigate } from "react-router";
const tabData = [
  {
    id: "highest_volume",
    title: "Highest Volume",
  },
  {
    id: "top_gainers",
    title: "Top Gainer",
  },
  {
    id: "top_losers",
    title: "Top Losers",
  },
];

export default function CurrencyTable() {
  const [activeTabs, setActiveTabs] = useState("highest_volume");
  const { webSocketCoinList, coinListData, selectedCurrency } =
    useContext(FlexLayerContext);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  return (
    <Box className="mainContainer" sx={{ margin: "50px 0px" }}>
      <Box className="displayCenter">
        <Box sx={{ width: "80%", textAlign: "center", marginBottom: "50px" }}>
          <Typography variant="h2">
            Buy Bitcoin, Taral and 150+ cryptocurrencies.
          </Typography>
        </Box>
      </Box>
      <Box className="displaySpacebetween">
        <Box>
          <Typography variant="h4">Your Next Profitable Trade</Typography>
        </Box>
        <Box>
          <FlexButton
            title="See All"
            color="default"
            sx={{
              color: colors.gold,
              fontSize: "16px",
              textTransform: "none",
            }}
            onClick={() => navigate("/market-overview")}
          />
        </Box>
      </Box>
      <Card sx={{ marginTop: "20px" }}>
        <Box
          className="displaySpacebetween "
          sx={{ borderBottom: "1px solid #FFCA65" }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={6} md={6} sm={6} xs={12}>
              {tabData &&
                tabData.map((item, index) => {
                  return (
                    <ButtonTabs
                      key={`btntabs${index}`}
                      item={item}
                      index={index}
                      activeTabs={activeTabs}
                      setActiveTabs={setActiveTabs}
                    />
                  );
                })}
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ width: { lg: "50%", xs: "100%" } }}>
                  <TextField
                    placeholder="Search by coin name, symbol..."
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ padding: "10px " }}>
          <CurrencyList
            search={search}
            activeTabs={activeTabs}
            coinList={coinListData}
            selectedCurrency={selectedCurrency}
            webSocketCoinList={webSocketCoinList}
          />
        </Box>
      </Card>
    </Box>
  );
}
